<script lang="ts">
    import {getInjector} from 'src/core';
    import LoginService from '../../login/login.service';

    export let additionalClasses = '';

    const loginService = getInjector().getByClass(LoginService);
</script>

<!-- svelte-ignore a11y-invalid-attribute because javascript:void(0) accessibility -->
<a class={additionalClasses} href="javascript:void(0)" on:click={() => loginService.goLogged('/users/current')}>
    <slot/>
</a>